export default function AuthorMethodology() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const principles = [
    { icon: 'ri-group-line', title: 'Отношения H2H', desc: 'Human-to-Human. За каждым столом переговоров — живые люди со своими страхами, амбициями и интересами. Бизнес не ведёт переговоры — люди ведут.' },
    { icon: 'ri-compasses-line', title: 'Интересы сторон', desc: 'Мы учим разделять позиции и интересы. Позиция — это «я хочу скидку 10%». Интерес — «мне нужно показать руководству, что я сэкономил». Работа с интересами меняет исход переговоров.' },
    { icon: 'ri-road-map-line', title: 'Долгосрочные отношения', desc: 'Одна сделка не стоит испорченных отношений. Мы учим переговорщиков видеть горизонт за пределами текущей встречи и строить партнёрства на годы вперёд.' },
    { icon: 'ri-vip-diamond-line', title: 'Ценность', desc: 'Переговоры — это не борьба за скидку, а поиск и создание ценности для обеих сторон. Мы учим расширять «пирог», а не делить его.' },
    { icon: 'ri-flashlight-line', title: 'Влияние', desc: 'Управление решениями другой стороны через правильные вопросы, метасообщения и невербальную коммуникацию. Не манипуляция — профессиональное влияние.' },
    { icon: 'ri-shield-line', title: 'Культура переговоров', desc: 'Формирование единого стандарта ведения переговоров в компании. Чтобы любой менеджер действовал по системе, а не по настроению.' },
    { icon: 'ri-question-answer-line', title: 'Сильные вопросы', desc: 'Искусство задавать вопросы, которые меняют ход переговоров. Вопросы, которые вскрывают истинные потребности, ограничения и критерии принятия решений.' },
    { icon: 'ri-chat-3-line', title: 'Метасообщения', desc: 'То, что передаётся между строк: тон, паузы, формулировки, контекст. Управление метасообщениями — навык, который отличает профессионального переговорщика.' },
    { icon: 'ri-eye-line', title: 'Невербальная коммуникация', desc: 'Язык тела, жесты, мимика — до 60% информации в переговорах передаётся невербально. Мы учим читать и управлять этими сигналами.' },
    { icon: 'ri-mental-health-line', title: 'Управление состоянием', desc: 'Способность сохранять ясность мышления под давлением. Техники саморегуляции для сложных и эмоционально заряженных переговоров.' },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-lightbulb-line"></i>
            Авторская методология
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Переговоры — это управление решениями, а не борьба за победу
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Философия, на которой построены все программы <strong>обучения переговорам</strong>. Это не набор техник — это система мышления, которая меняет подход к любым <strong>деловым переговорам</strong>.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
          {principles.map((item, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-5 hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 group cursor-default">
              <div className="w-11 h-11 bg-teal-100 rounded-lg flex items-center justify-center mb-3 group-hover:bg-teal-600 transition-colors duration-300 flex-shrink-0">
                <i className={`${item.icon} text-lg text-teal-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button
            onClick={() => scrollTo('contact')}
            className="bg-teal-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Обсудить внедрение в компании
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}